import { lazy, Suspense } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

// components
import { Layout, LoadingScreen } from '../components';
// config
import config from '../config';
// guards
import AuthGuard from '../guards/AuthGuard';
import NoAccess from '../pages/NoAccess';

// ----------------------------------------------------------------------

const PATH_AFTER_LOGIN = `${config.BASE_NAME}/referrals`;

// ----------------------------------------------------------------------

const Loadable = (Component: any) => (props: any) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

const Router = () => {
  return useRoutes([
    // Home
    {
      path: '/np/dashboard',
      element: (
        <AuthGuard>
          <Layout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: ':tab', element: <Home /> },
        { path: ':tab/study/:studyId/:innerTab', element: <Home /> },
      ],
    },

    // redirect to specific page after login
    { path: '/', element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },

    {
      path: '*',
      element: <Layout />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '401', element: <NoAccess /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
};

// IMPORT COMPONENTS

const Home = Loadable(lazy(() => import('../pages/Home')));
const NotFound = Loadable(lazy(() => import('../pages/NotFound')));
export default Router;
